import React from 'react';
import './Loading.css';
import Spinner from '../Spinner/Spinner';
import logComponent from '../../common/logComponent';

export default function Loading({ message }) {
  if (logComponent('Loading')) { console.debug('Loading rendered'); }

  const displayMessage = message ? message : null;

  return (
    <div className="Loading">
    {
      message &&
        <p className="Loading__message">{displayMessage }</p>
    }  
      <div className="Loading__spinner">      
        <Spinner />
      </div>
    </div>
  )
}
